/* Efizi · Header reduzido (Essencial): mostra a faixa fina ao rolar + espelha a contagem do carrinho. */
(function () {
  function init() {
    var bar = document.getElementById('EfiziMiniHeader');
    if (!bar) return;

    var THRESHOLD = 200;
    function onScroll() {
      if (window.scrollY > THRESHOLD) {
        bar.classList.add('is-visible');
      } else {
        bar.classList.remove('is-visible');
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* espelha a contagem do carrinho do tema (atualiza sem reload) */
    var badge = bar.querySelector('[data-mini-cart-count]');
    var themeCount = document.querySelector('.cart-item-count, .cart-count-bubble span[aria-hidden], cart-count');
    function sync() {
      if (!badge) return;
      var n;
      if (themeCount) {
        var m = (themeCount.textContent || '').match(/\d+/);
        n = m ? parseInt(m[0], 10) : 0;
      } else {
        n = parseInt(badge.getAttribute('data-initial') || '0', 10);
      }
      badge.textContent = n;
      badge.style.display = n > 0 ? '' : 'none';
    }
    sync();
    if (themeCount && window.MutationObserver) {
      new MutationObserver(sync).observe(themeCount, { childList: true, characterData: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
